import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { employeeTeams } from 'modules/teams/store/employeeTeams'

export default (item: PaymentItem, value: Value) => {
  /*
    Note: this filter values will be used on employee matcher page,
     result items index page and payment selector page
     the initial matched data on employee matcher page
    might not be linked to a user, also the
    item does not have attribute employee_id
    at this stage because it has not been saved.
     Only saved items contains employee_id
     We should not apply any filter when employee_id or userId is not set
  */
  if (!item.attributes.employee_id && !(item.has('userId') && item.attributes.userId)) {
    return true
  }

  let employee: Employee | null | undefined = employees.get(item.attributes.employee_id)

  if (!employee && item.has('userId')) {
    const user = users.find({
      id: item.attributes.userId,
    })
    employee =
      user && !user.isNew
        ? employees.find({
            access_id: user.attributes.id,
          })
        : undefined
  }

  if (!employee) return

  switch (value) {
    case 'employee_status':
      return employee

    case 'employee_name':
      const u = users.get(employee.attributes.access_id)
      return u
        ? getFullDisplayName({
            firstName: u.attributes.first_name,
            lastName: u.attributes.last_name,
            canSharePreferredName: employee.policy.can('sharePreferredName'),
            preferredName: employee.attributes.preferred_name,
          })
        : undefined

    case 'location':
      return employee.attributes.location_id

    case 'team':
      return employeeTeams(teams, memberships, employee.id).map((team) => team.attributes.id)

    case 'legal_entity':
      return employeeLegalEntityId(employee)
  }
}
